import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "#fff",
    borderRadius: "24px",
    borderTop: "6px solid #008751",
    boxShadow: "0 15px 35px rgba(0, 0, 0, 0.2)",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  contentWrapper: {
    display: "flex",
    gap: { xs: "16px", md: "20px" },
    height: "100%",
    padding: { xs: "20px", sm: "24px" },
    boxSizing: "border-box",
    "@media (max-width: 700px)": { flexDirection: "column" },
  },
  textSection: {
    flex: "1.5 1 0",
    minWidth: 0,
    textAlign: "left",
    "@media (max-width: 700px)": { order: 2 },
  },
  title: {
    color: "#008751",
    marginBottom: "3px",
    fontSize: "clamp(16px, 1.4vw, 20px)",
    fontWeight: 700,
    lineHeight: 1.6,
  },
  hindiTitle: {
    display: "block",
    color: "#555",
    fontSize: "14px",
    paddingBottom: "8px",
    marginBottom: "12px",
    fontWeight: 500,
    lineHeight: 1.45,
    borderBottom: "1px solid #999",
  },
  englishDescription: {
    fontSize: "clamp(13px, 0.9vw, 15px)",
    lineHeight: 1.9,
    color: "#2c3e50",
    marginBottom: "12px",
    textAlign: "justify",
  },
  hindiDescriptionBox: {
    color: "#555",
    backgroundColor: "#f1f8f4",
    padding: "12px",
    borderLeft: "3px solid #008751",
  },
  hindiDescription: {
    fontSize: "clamp(12.5px, 0.85vw, 14px)",
    lineHeight: 1.9,
    textAlign: "justify",
  },
  qrSection: {
    flex: "1 1 0",
    minWidth: "190px",
    backgroundColor: "#f9fbf9",
    borderRadius: "12px",
    padding: { xs: "14px", sm: "20px" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #eef2ee",
    "@media (max-width: 700px)": { order: 1, minWidth: 0 },
  },
  schedule: { textAlign: "center", fontSize: "14px", lineHeight: 1.7 },
  scheduleHighlight: { color: "#008751", fontWeight: 600 },
  scheduleNote: { color: "#666", fontSize: "13px" },
  qrImage: {
    width: { xs: "136px", sm: "160px" },
    height: { xs: "136px", sm: "160px" },
    marginTop: "14px",
    padding: "8px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
  },
  scanText: { marginTop: "12px", fontWeight: 700, textAlign: "center" },
  meetingLink: {
    color: "#d93025",
    fontSize: "14px",
    margin: "8px 0 14px",
    textAlign: "center",
    wordBreak: "break-all",
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  },
  joinButton: {
    width: "100%",
    maxWidth: "220px",
    padding: "10px 18px",
    borderRadius: "8px",
    backgroundColor: "#008751",
    fontWeight: 700,
    textTransform: "none",
    transition: "transform 0.2s",
    "&:hover": {
      backgroundColor: "#006b40",
      transform: "translateY(-2px)",
    },
  },
});

export default styles;
